import React from 'react';
import s from './ActionBarItemContentWrapper.scss';
/**
 * Provides styling for the content of our `ActionBar` item components.
 *
 * See `ActionBarButton` for examples.
 */ const ActionBarItemContentWrapper = ({ children })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, children);
};
ActionBarItemContentWrapper.displayName = 'ActionBarItemContentWrapper';
export default ActionBarItemContentWrapper;

//# sourceMappingURL=ActionBarItemContentWrapper.js.map